import type { Level } from "@shared/access/levels";
import type { ResourcePath } from "@shared/access/resources";
import { usePermission, type PlaceRef } from "../../auth/access";

/** A `PermissionGate`'s resource, level and place, as the route declares them. */
export interface Gate {
  readonly resource: ResourcePath;
  readonly level: Level;
  readonly place: PlaceRef;
}

const atNenda = (resource: ResourcePath): Gate => ({
  resource,
  level: "administrate",
  place: "nenda",
});

export const AUTHOR_TITLES = atNenda("distribution/titles");
export const AUTHOR_PACKAGES = atNenda("distribution/packages");
export const AUTHOR_CHANNELS = atNenda("distribution/channels");
export const AUTHOR_RAILS = atNenda("distribution/rails");
export const AUTHOR_SUPPLIERS = atNenda("distribution/suppliers");
export const TRUST_SUPPLIERS = atNenda("supplier-trust");
/** Nenda channels: Nenda-wide signage playlists, which are global items. */
export const AUTHOR_NENDA_CHANNELS: Gate = {
  resource: "signage",
  level: "administrate",
  place: "global",
};

/** The same answer as `<PermissionGate {...gate}>`. */
export function useGate(gate: Gate): boolean {
  return usePermission(gate.resource, gate.level, gate.place);
}
